/* eslint-disable
    func-names,
    max-len,
    no-cond-assign,
    no-console,
    no-param-reassign,
    no-shadow,
    no-unused-vars,
    no-var,
    vars-on-top,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection class for dealing with many Stores
// This fetches the data for you and has all the properties
// dependency on lodash
require('../service/apolloService');

const factory = function (Store, MainApi, $q, $rootScope, _, apolloService) {
  var Collection = (function () {
    let lodashMethods;
    let collectionLodashMethods;
    let nonCollectionLodashMethods;
    Collection = class Collection extends Store {
      static initClass() {
        this.prototype.$graphqlClient = apolloService;
        this.prototype.data = [];
        this.prototype.$method = 'GET'; // method of call
        this.prototype.$resource = ''; // resource name (will send call to `resource.json`
        this.prototype.$$useCachedModels = true; // use cached models if already cached
        this.prototype.$$cacheModels = false; // force all models to be cached

        this.prototype.$loaded = false;
        this.prototype.$resolved = true; // false if ajax call ajax call is not yet resolved
        this.prototype.$promise = {};
        this.prototype.$apiService = MainApi;
        this.prototype.$paramNames = { page: 'page' };

        // Declare the type of Store we want to use for this collection
        this.prototype.$type = Store;

        // inject lodash functions
        lodashMethods = [
          'forEach',
          'map',
          'reduce',
          'reduceRight',
          'find',
          'filter',
          'reject',
          'every',
          'some',
          'includes',
          'invokeMap',
          'max',
          'maxBy',
          'min',
          'minBy',
          'toArray',
          'size',
          'head',
          'take',
          'initial',
          'tail',
          'drop',
          'last',
          'without',
          'difference',
          'indexOf',
          'shuffle',
          'lastIndexOf',
          'isEmpty',
          'chain',
          'sampleSize',
        ];

        // lodash methods that return a collection
        collectionLodashMethods = [
          'chain',
          'drop',
          'difference',
          'each',
          'every',
          'filter',
          'forEach',
          'head',
          'initial',
          'invokeMap',
          'inject',
          'last',
          'max',
          'maxBy',
          'min',
          'minBy',
          'map',
          'reject',
          'take',
          'reduce',
          'shuffle',
          'reduceRight',
          'shuffle',
          'sampleSize',
          'tail',
          'without',
        ];

        nonCollectionLodashMethods = _.difference(lodashMethods, collectionLodashMethods);

        _.each(
          nonCollectionLodashMethods,
          method =>
            (Collection.prototype[`$${method}`] = function (...args) {
              args.unshift(this.data);
              return _[method].apply(this, args);
            }),
        );

        // returns a collection that has contains non-cached models
        // that are the result of the respective lodash function.
        // If the collection is set to $listen to the original collection,
        // it will continue to transform models.
        // see test for details on https://github.com/BenchLabs/rind/blob/master/src/data/util/collection.spec.coffee#L76-76
        _.each(
          collectionLodashMethods,
          method =>
            (Collection.prototype[`$${method}`] = function (...args) {
              const newCollection = new this.constructor(); // create new collection of the same type
              newCollection.$$useCachedModels = false; // force anonymous models to be used
              newCollection.$listenTransformFn = (
                data, // allow asynchronous updates from parents
              ) => _[method].apply(this, [data].concat(args));
              if (this.$lastUpdated > 0) {
                newCollection.$set(newCollection.$listenTransformFn(this.$data()));
              } // initial set
              return newCollection;
            }),
        );
      }

      $length() {
        return this.data.length;
      }

      $validate(collection = this.data) {
        const errors = [];
        // allows us to pass arbitrary objects that match the model schema
        const modelTemplate = new this.$type();
        for (const model of collection) {
          var error;
          if (!_.isEmpty((error = modelTemplate.$validate(model)))) {
            errors.push(error);
          }
        }
        return errors;
      }

      $serialize(data) {
        const modelClass = this.$type;
        const modelSerialize = modelClass.prototype.$serialize.bind(modelClass);
        return _.map(data, modelData => modelSerialize(modelData));
      }

      $serializeMeta(data) {
        return {};
      }

      // called to prepare data from the model for server consumption
      // used in $put and $post
      $deserialize(data) {
        const modelClass = this.$type;
        const modelDeserialize = modelClass.prototype.$deserialize.bind(modelClass);
        return _.map(data, modelData => modelDeserialize(modelData));
      }

      // api client that updates the $resolved variable
      $apiCall(options) {
        this.$resolved = false;

        const apiCallPromise = this.$apiService.request(options);

        const newPromise = $q.all([this.$promise, apiCallPromise]);

        this.$promise = newPromise;

        newPromise.finally(res => {
          // if no new calls have been made
          if (this.$promise === newPromise) {
            this.$resolved = true;
          }
          return res;
        });

        return apiCallPromise;
      }

      $cacheId() {
        return `${this.$className()}-collection-${this.$storeId()}`;
      }

      $data() {
        return _.map(this.data, model => model.$data());
      }

      $set(data = [], opts = {}, meta = {}) {
        if (data instanceof Array) {
          let dataToSet = _.map(data, obj => {
            const uncachedObj = new this.$type();
            uncachedObj.$set(obj);

            // only use cached objects if they are already in cache
            // or cache is explicitly forced
            if (
              (this.$$useCachedModels && Store.$checkCache(uncachedObj.$cacheId())) ||
              this.$$cacheModels
            ) {
              const cachedObj = new this.$type(obj);
              cachedObj.$onDestroy(this.$onModelDestroy.bind(this));
              return cachedObj;
            }
            return uncachedObj;
          });

          // check for reset option
          // extend @data with new models
          if (!opts.reset && this.$$cacheModels) {
            dataToSet = _.union(dataToSet, this.data);
          }

          return super.$set(_.assignIn(meta, { data: dataToSet }));
        }
        if (typeof data === 'object') {
          return super.$set(data, opts);
        }
      }

      // creates a new model and adds the data to a collection.
      $add(data) {
        const model = new this.$type(data);
        this.$set(this.$data().concat([model]));
        return model;
      }

      $findById(id) {
        return this.$find(model => String(model.$storeId()) === String(id));
      }

      $remove(model) {
        const modelStoreId = model.$storeId();
        if (modelStoreId && this.$findById(modelStoreId) != null) {
          return this.$removeById(model.$storeId());
        }
      }

      $removeById(id) {
        const model = this.$findById(id);
        const index = this.data.indexOf(model);
        if (index !== -1) {
          return this.$removeAtIndex(index);
        }
      }

      $removeAtIndex(index) {
        const newData = this.$data();
        newData.splice(index, 1);
        this.$set(newData, { reset: true });
        return this.$data();
      }

      $empty() {
        return (this.data.length = 0);
      }

      $destroy() {
        this.$destroyData();
        return super.$destroy();
      }

      $destroyData() {
        return _.each(this.data, model => model.$destroy());
      }

      $fetchPage(page) {
        this.page = page;
        return this.$fetch();
      }

      $url() {
        return `${this.$resource}.json`;
      }

      $getUrl() {
        return (typeof this.$url === 'function' ? this.$url() : undefined) || this.$url || '';
      }

      $params() {
        // could use _.pick here, but this allows us to write
        // things like $paramNames = {param1: 'foo.bar[0].baz', 'id'}
        return _.reduce(
          this.$paramNames,
          (acc, attr, name) => {
            const val = typeof attr === 'function' ? attr.apply(this) : _.get(this, attr);
            if (val != null && val !== '') {
              return _.set(acc, name, val);
            }
            return acc;
          },
          {},
        );
      }

      $fetch(options = { reset: false }, params = {}) {
        if (!this.$storeId()) {
          return $q.reject(new Error('Collection fetch failed: no store ID'));
        }

        const queryParams = angular.extend(this.$params(), params);
        params = {
          url: this.$getUrl(),
          method: this.$method,
          params: queryParams,
        };

        return this.$apiCall(angular.extend(params, options)).then(
          res => {
            if (res.data != null) {
              this.$set(
                this.$serialize(res.data),
                { reset: options.reset },
                this.$serializeMeta(res.data),
              );
            }

            this.$loaded = true;
            this.$resolved = true;

            return res;
          },
          err => console.error(this.$getUrl(), ' failed with ', err),
        );
      }

      $$filterData(data) {
        return data;
      }

      $onModelDestroy(e, model) {
        return this.$removeById(model.$storeId());
      }

      // all models in collection will be cached
      $cacheAllModels() {
        this.$$cacheModels = true;
        _.forEach(this.data, model => {
          model.$cache();
          return model.$onDestroy(this.$onModelDestroy.bind(this));
        });
        return this;
      }

      $gqlData() {
        return this.data.map(i => ({
          ...i.$data(),
          __typename: i.constructor.name,
        }));
      }
    };
    Collection.initClass();
    return Collection;
  })();

  return Collection;
};

module.exports = factory;
